(() => {
  const barbecueReservationBreakdown = '.barbecue-reservation-breakdown'
  const planBlockRight = '.plan-block-right'
  const userInputRight = '.user-input-right'
  const eventReservationsInfoRight = '.event-reservations-info-right'
  const jsBarbecueReservationModal = '.js-barbecue-reservation-modal'

  const init = () => {
    $('body').on('click', barbecueReservationBreakdown, rescissionFixedMenu)
      .on('hide.bs.modal', jsBarbecueReservationModal, setFixedMenu)
  }

  const rescissionFixedMenu = e => {
    $(planBlockRight).attr("style", "position: relative !important;");
    $(userInputRight).attr("style", "position: relative !important;");
    $(eventReservationsInfoRight).attr("style", "position: relative !important;");
  }

  const setFixedMenu = e => {
    if ( $(window).width() > 915 ) {
      $(planBlockRight).attr("style", "position: sticky;");
      $(userInputRight).attr("style", "position: sticky;");
      $(eventReservationsInfoRight).attr("style", "position: sticky;");
    } else {
      $(planBlockRight).attr("style", "position: relative;");
      $(userInputRight).attr("style", "position: relative;");
      $(eventReservationsInfoRight).attr("style", "position: relative;");
    }
  }
  $(init);
})();
